import saveTask from './saveTask'
import uploadFilesTask from './uploadFilesTask'

export const saveTaskService = saveTask
export const uploadFilesTaskService = uploadFilesTask
